export default {
    component: 'aggregate_parameter_config',
    name: 'aggregate_parameter_config',
    fields: [{
        name: 'Rule ID',
        param: 'rule_id',
        type: 'text',
        identifier: true,
        required: true,
      },
      {
        name: 'Rule',
        param: 'rule',
        type: 'json',
      },
      {
        name: 'Comments',
        param: 'comments',
        type: 'text',
      }
    ]
  }
